// extracted by mini-css-extract-plugin
export default {"Image":"Slide_Image__3VX+P","Slide":"Slide_Slide__tSLA6","Name":"Slide_Name__H5TAa","Parts":"Slide_Parts__JGvj1","Time":"Slide_Time__WnfU3"};